<template>
  <div class="animated fadeIn fadeOut">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Policy
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WebCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Policy</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Policy Info
            </div>
          </div>
          <hr>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_created_at">
                Registed_at
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_created_at" v-if="model && model.created_at">{{model.created_at | sdate}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_registed_at">
                Last Modify
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_registed_at" v-if="model && model.updated_at">{{model.updated_at | sdate}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_is_publish" v-b-tooltip.hover title="rule can be a publish or prepare deploy">Publish</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_publish" :disabled="lock">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_created_at" v-b-tooltip.hover title="Status about rule, enable or disable">Status</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="version" v-b-tooltip.hover title="New Version is more highier then latest version">
                CRS Rule(+ Vender Rule) Version
                <span class="font-weight-light font_13" v-if="last_version && !model.id">Latest : {{last_version}}</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input :state="model.version != null && model.version != '' ? true : false" :disabled="lock" v-model="model.version"></b-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="agent_version" v-b-tooltip.hover title="New Version is more highier then latest version">
                Required Minimum Agent Version
                <span class="font-weight-light font_13" v-if="last_version && !model.id">Latest : {{last_version}}</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input :state="model.agent_version != null && model.agent_version != '' ? true : false" :disabled="lock" v-model="model.agent_version"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Manage">
                Search
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              Press Control + F
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Manage">
                Manage
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-button size="sm" variant="danger" @click="confirm_remove = true" :disabled="!(model && model.id) || lock"> Delete </b-button>
            </b-col>
          </b-row>
          <div class="d-flex flex-wrap mt-5">
            <div class="mr-auto">
              <!-- <button type="button" class="btn btn-warning" :disabled="model.is_del" @click="() => { model && model.id ? confirm_update = true : save() }">
                Save
              </button> -->
              <b-button class="btn" :variant="lock ? 'warning' : 'add'" @click="() => { lock ? edit() : save() }">{{ lock ? 'Edit' : 'Save' }}</b-button>
            </div>
            <div class="mr-2">
              <b-button class="btn" variant="primary" @click="list">List</b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="6">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              CRS RULE
            </div>
          </div>
          <hr>
          <codemirror @change="change" ref="cm_rule" v-model="model.crs_rule" :options="options_rule"/>
          <!-- <prism-editor @change="change" :code="model.crs_rule" language="html"></prism-editor> -->
          <hr>

        </b-card>
      </b-col>
      <b-col lg="12" xl="6">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              CRS RULE JSON :
              <b-badge variant="success" v-if="json_validation">Good</b-badge>
              <b-badge v-else variant="secondary">Bad Json format</b-badge>
            </div>
          </div>
          <hr>
          <!-- <prismEditor @change="change_json" :code="model.crs_json" language="json" /> -->
          <!-- <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor> -->
          <!-- <editor-content :editor="editor" /> -->
          <codemirror @input="(x) => change_json(x)" ref="cm_json" v-model="model.crs_json" :options="options_json"/>
          <hr>
        </b-card>
      </b-col>
    </b-row>
    <!-- start modal area -->
    <b-modal title="Content Remove" header-bg-variant="danger" class="modal-danger" v-model="confirm_remove" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark">
      Are you sure you want to delete the data?
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
